import { render, staticRenderFns } from "./AddAttrValue.vue?vue&type=template&id=6ff9e78f&scoped=true"
import script from "./AddAttrValue.vue?vue&type=script&lang=js"
export * from "./AddAttrValue.vue?vue&type=script&lang=js"
import style0 from "./AddAttrValue.vue?vue&type=style&index=0&id=6ff9e78f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff9e78f",
  null
  
)

export default component.exports